export function transform2rgba(arr) {
    arr[3] = parseFloat(arr[3] / 255 as unknown as string);
    return `rgba(${arr.join(', ')})`;
}

export function rgbaToRgb(rgba) {
    const result = rgba.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+(\.\d)?)[\s+]?/i);
    return (result && result.length >= 4) ? `R:${result[1]} G:${result[2]} B:${result[3]}` : rgba;
}

export function rgbaToHexA(rgba) {
    const result = rgba.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+(\.\d)?)[\s+]?/i);
    return (result && result.length >= 4)
        ? {
            hex: (`#${
                (`0${parseInt(result[1], 10).toString(16)}`).slice(-2)
            }${(`0${parseInt(result[2], 10).toString(16)}`).slice(-2)
            }${(`0${parseInt(result[3], 10).toString(16)}`).slice(-2)}`).toUpperCase(),
            o: +result[4],
        } : rgba;
}
